import { formatDate } from "@helper/dateHelper";
import { callApi } from "./index"

export const getUnavailableSuppliers = (date: Date): Promise<number[]> => {
  return callApi(`/api/EasyDirectoryAPI/unavailable-suppliers?weddingDate=${formatDate(date)}`, { });
}
